import { z } from "zod";

import { AudienceFilterList } from "./audiences";

export const TrafficConfigTargetingFilterList = [
  "equals",
  "contains",
  "startsWith",
  "endsWith",
  "doesNotEqual",
  "doesNotContain",
  "doesNotStartWith",
  "doesNotEndWith",
  "isNull",
  "isNotNull",
  "",
] as const;

// export type ExperiencePageTargetingFilter =
//   (typeof TrafficConfigTargetingFilterList)[number];

export const ExperiencePageTargetingFilterTypeList = [
  "utm",
  "url",
  "device",
  "visitor",
  "jsExpression",
  "trafficSource",
  "country",
  "referrer",
  "cookie",
] as const;
export type TrafficConfigFilterType =
  (typeof ExperiencePageTargetingFilterTypeList)[number];

export const ExperiencePageTargetingDtoSchema = z.object({
  id: z.string().uuid(),
  filter: z.enum(AudienceFilterList).nullish(),
  filterType: z.enum(ExperiencePageTargetingFilterTypeList).default("url"),
  value: z.string(),
  order: z.number(),
  experienceId: z.string().uuid().optional(),
});

export type ExperiencePageTargetingDto = z.infer<
  typeof ExperiencePageTargetingDtoSchema
>;

export const CreateExperiencePageTargetingDtoSchema =
  ExperiencePageTargetingDtoSchema.extend({
    experienceId: z.string().uuid().optional(),
  });
